<app-loading-spinner [active]="loading || loadingPulverized"
    [customMessage]="loadingPulverized ? (pulverizada ? 'Pulverizando... Aguarde...' : 'Retirando pulverização... Aguarde...') : ''"
    [persistentMessage]="loadingPulverized"></app-loading-spinner>

<ng-container>
    <form [formGroup]="form" (keydown.enter)="handleKeyEnter($event)">
        <div class="row no-gutters w-100">
            <div class="col-12 col-lg-10">
                <div class="row">
                    <div class="col-12 col-lg-11">
                        <div class="info-message">
                            <svg-icon
                                src="assets/images/icon-info.svg"></svg-icon>
                            <span>
                                Para prosseguir, sua composição societária deve
                                ter 100% de participação ou pelo menos um sócio
                                cadastrado.
                            </span>
                        </div>
                        <app-spacer [bottom]="8"></app-spacer>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-11">
                        <div class="info-message">
                            <svg-icon
                                src="assets/images/icon-info.svg"></svg-icon>
                            <span>
                                Obrigatório informar todas as pessoas jurídicas
                                e
                                naturais da cadeia societária, até alcançar a
                                pessoa natural caracterizada como beneficiário
                                final.
                            </span>
                        </div>
                        <app-spacer [bottom]="8"></app-spacer>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-11">
                        <span class="sub-text">
                            Considera-se beneficiário final a pessoa natural que
                            direta ou indiretamente possui mais de
                            25%
                            do capital
                            ou detém/exerce a preponderância nas deliberações
                            sociais da sociedade.
                        </span>
                        <app-spacer [bottom]="37"></app-spacer>
                    </div>
                </div>

                <ng-container *ngIf="showForm">
                    <div class="row">
                        <ng-container
                            *ngIf="authService.user.active_register.register.role.slug !== getSlugLabel()">
                            <div class="col-12 col-lg-4">
                                <app-masked-input [group]="form"
                                    controlName="document" label="CPF / CNPJ"
                                    placeholder="000.000.000-00"
                                    [errorText]="invalidDocument ? 'não é possível adicionar o próprio CNPJ como sócio!' : 'Campo inválido' "
                                    documentType="cpfOrCnpj">
                                </app-masked-input>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>
                        </ng-container>

                        <div class="col-12 col-lg-8">
                            <app-input [group]="form" controlName="full_name"
                                label="Nome Completo / Razão Social"
                                [readOnly]="foundPerson">
                            </app-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>

                    <div class="row">
                        <ng-container
                            *ngIf="authService.user.active_register.register.role.slug !== getSlugLabel()">
                            <div class="col-12 col-lg-4">
                                <app-input [group]="form"
                                    controlName="percentage" type="number"
                                    label="% Participação" placeholder="00%"
                                    [max]="100">
                                </app-input>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>
                        </ng-container>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <app-radio [multiple]="true" formControlName="pep">
                                <div class="flex-1 d-flex flex-column">
                                    <span class="pep-title">PEP</span>
                                    <app-spacer [bottom]="8"></app-spacer>
                                    <span class="pep-description">Considera-se
                                        Pessoa Exposta Politicamente (PEP), nos
                                        termos da legislação
                                        em
                                        vigor, (i) agente público que desempenha
                                        ou tenha desempenhado, nos últimos
                                        cinco
                                        anos, no Brasil ou
                                        em
                                        países, territórios e dependências
                                        estrangeiras, cargos, empregos ou
                                        funções
                                        públicas relevantes; ou
                                        (ii)
                                        representante, familiar (parente na
                                        linha reta até primeiro grau, cônjuge,
                                        companheiro(a) ou
                                        enteado(a)).</span>
                                </div>
                            </app-radio>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12">
                            <app-radio [multiple]="true"
                                formControlName="pep_relationship">
                                <div class="flex-1 d-flex flex-column">
                                    <span class="option-title">
                                        Possuo relacionamento com pessoa
                                        politicamente exposta
                                    </span>
                                </div>
                            </app-radio>

                            <ng-container
                                *ngIf="form.controls.pep_relationship.value">
                                <app-spacer [bottom]="24"></app-spacer>
                                <div class="row ml-2">
                                    <div class="offset-1 col-7">
                                        <app-masked-input [group]="form"
                                            controlName="pep_relationship_document"
                                            label="CPF da pessoa"
                                            placeholder="000.000.000-00"
                                            mask="000.000.000-00">
                                        </app-masked-input>

                                        <app-spacer [bottom]="24"></app-spacer>
                                    </div>
                                </div>

                                <div class="row ml-2">
                                    <div class="offset-1 col-7">
                                        <app-input [group]="form"
                                            controlName="pep_relationship_name"
                                            label="Nome da pessoa"
                                            [maxLength]="60"
                                            [readOnly]="foundRelationPerson">
                                        </app-input>

                                        <app-spacer [bottom]="24"></app-spacer>
                                    </div>
                                </div>

                                <div class="row ml-2">
                                    <div class="offset-1 col-7">
                                        <app-input [group]="form"
                                            controlName="pep_bond"
                                            label="Vínculo" [maxLength]="20">
                                        </app-input>
                                    </div>
                                </div>
                            </ng-container>
                            <app-spacer [bottom]="48"></app-spacer>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <app-button (onClick)="handleTriggerForm(0)"
                                [disabled]="form.invalid" class="add-button"
                                [outline]="true" [loading]="sending">
                                <svg-icon src="assets/images/icon-add.svg"
                                    class="mr-2"></svg-icon>
                                Adicionar sócio
                            </app-button>
                            <app-spacer [bottom]="72"></app-spacer>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

        <div class="row no-gutters w-100">
            <div class="col-12 col-lg-10">
                <ng-container
                    *ngIf="!showForm && formattedData && formattedData.length > 0 && formattedData[0].shareholders && formattedData[0].shareholders.length > 0">
                    <div class="row">
                        <div class="col-12 col-lg-11 pl-0 pr-0"
                            style="overflow-x:auto;">
                            <div class="composition-table">
                                <div class="table-body">
                                    <ng-container
                                        *ngFor="let item of formattedData; let i = index">
                                        <div class="table-row-wrapper">
                                            <div class="main-row"
                                                [class.has-children]="item.shareholders.length > 0"
                                                [class.clickable]="item.shareholders.length > 0"
                                                (click)="item.shareholders.length > 0 && handleSetCollapsed(i, item.isOpen)">
                                                <div
                                                    class="expand-button-container">
                                                    <ng-container
                                                        *ngIf="item.shareholders.length > 0">
                                                        <button
                                                            (click)="$event.stopPropagation(); handleSetCollapsed(i, item.isOpen)"
                                                            class="expand-button">
                                                            <svg-icon
                                                                src="assets/images/icon-right.svg"
                                                                *ngIf="!item.isOpen"></svg-icon>
                                                            <svg-icon
                                                                src="assets/images/icon-down.svg"
                                                                *ngIf="item.isOpen"></svg-icon>
                                                        </button>
                                                    </ng-container>
                                                    <div *ngIf="item.shareholders.length === 0"
                                                        style="width: 26px;">
                                                    </div>
                                                </div>

                                                <div class="main-row-content">
                                                    <div class="name-cell">
                                                        <div
                                                            class="name-primary-container">
                                                            <div
                                                                class="name-primary">
                                                                {{item.full_name}}
                                                            </div>
                                                        </div>
                                                        <div class="name-secondary"
                                                            *ngIf="item.document">
                                                            {{item.document}}
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="participation-cell">
                                                        <!-- Participação total removida daqui, aparece no header da tabela aninhada -->
                                                        <ng-container
                                                            *ngIf="item.shareholders.length === 0 && item.percentage">
                                                            {{item.percentage}}%
                                                        </ng-container>
                                                    </div>

                                                    <!-- Badge de status apenas no card principal, alinhado à direita -->
                                                    <div class="badge-cell"
                                                        *ngIf="item.full_name === getCompanyName()">
                                                        <span
                                                            class="composition-status-badge"
                                                            [class.complete]="isCompositionComplete()"
                                                            [class.incomplete]="!isCompositionComplete()">
                                                            {{isCompositionComplete()
                                                            && pulverizada &&
                                                            getShareholdersPercentage()
                                                            < 100
                                                                ? 'Participação societária completa (Pulverizada)'
                                                                :
                                                                isCompositionComplete()
                                                                ? 'Participação societária completa'
                                                                : 'Participação societária incompleta'
                                                                }} </span>
                                                    </div>

                                                    <div>
                                                        <div
                                                            class="icon-container">
                                                            <!-- Botão de adicionar para o grupo principal quando participação não for 100% -->
                                                            <ng-container
                                                                *ngIf="item.full_name === getCompanyName() && getShareholdersPercentage(item.id) < 100">
                                                                <app-tooltip
                                                                    text="Adicionar sócio"
                                                                    position="left">
                                                                    <button
                                                                        (click)="$event.stopPropagation(); handleTriggerForm(undefined, true)"
                                                                        class="action-button"
                                                                        type="button">
                                                                        <svg-icon
                                                                            src="assets/images/icon-add.svg"></svg-icon>
                                                                    </button>
                                                                </app-tooltip>
                                                            </ng-container>

                                                            <!-- Botão de adicionar apenas para empresas (CNPJ), não para CPF -->
                                                            <ng-container
                                                                *ngIf="item.full_name !== getCompanyName() && item.document && isCNPJ(item.document) && item.id !== undefined">
                                                                <app-tooltip
                                                                    text="Adicionar Sócio"
                                                                    position="top">
                                                                    <button
                                                                        (click)="$event.stopPropagation(); handleTriggerForm(item.id, true)"
                                                                        class="action-button"
                                                                        type="button">
                                                                        <svg-icon
                                                                            src="assets/images/icon-add.svg"></svg-icon>
                                                                    </button>
                                                                </app-tooltip>
                                                            </ng-container>

                                                            <ng-container
                                                                *ngIf="item.id !== undefined">
                                                                <app-tooltip
                                                                    text="Editar"
                                                                    position="top">
                                                                    <button
                                                                        (click)="$event.stopPropagation(); handleEdit(item)"
                                                                        class="action-button"
                                                                        type="button">
                                                                        <svg-icon
                                                                            src="assets/images/icon-edit.svg"></svg-icon>
                                                                    </button>
                                                                </app-tooltip>

                                                                <app-tooltip
                                                                    text="Excluir"
                                                                    position="top">
                                                                    <button
                                                                        (click)="$event.stopPropagation(); handleRemoveModal(item)"
                                                                        class="action-button"
                                                                        type="button">
                                                                        <svg-icon
                                                                            src="assets/images/icon-trash.svg"></svg-icon>
                                                                    </button>
                                                                </app-tooltip>
                                                            </ng-container>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Tabela aninhada para shareholders -->
                                            <div class="nested-table-container"
                                                *ngIf="item.shareholders.length > 0 && item.isOpen && !item.collapsed">
                                                <div
                                                    class="nested-table-header">
                                                    <h6>Participantes de
                                                        {{item.full_name}}</h6>
                                                    <div
                                                        class="total-percentage-header">
                                                        Participação total:
                                                        {{ pulverizada &&
                                                        item.full_name ===
                                                        getCompanyName() ? '100%
                                                        (Pulverizada)' :
                                                        getShareholdersPercentage(item.id)
                                                        + '%' }}
                                                    </div>
                                                </div>
                                                <div
                                                    class="nested-table-wrapper">
                                                    <div
                                                        class="nested-table-content">
                                                        <!-- Títulos das colunas dentro do card -->
                                                        <div
                                                            class="nested-table-columns-header">
                                                            <div
                                                                class="header-cell name-header">
                                                                Nome / Razão
                                                                Social</div>
                                                            <div
                                                                class="header-cell participation-header">
                                                                % Participação
                                                            </div>
                                                            <div
                                                                class="header-cell actions-header">
                                                            </div>
                                                        </div>
                                                        <ng-container
                                                            *ngFor="let shareholder of item.shareholders; let j = index">
                                                            <div class="nested-row-wrapper"
                                                                [class.has-nested-children]="shareholder.shareholders && shareholder.shareholders.length > 0">
                                                                <div
                                                                    class="nested-row-main">
                                                                    <div
                                                                        class="nested-expand-container">
                                                                        <ng-container
                                                                            *ngIf="shareholder.shareholders && shareholder.shareholders.length > 0">
                                                                            <button
                                                                                (click)="handleSetCollapsedShareholder(item, j, shareholder.isOpen)"
                                                                                class="expand-button">
                                                                                <svg-icon
                                                                                    src="assets/images/icon-right.svg"
                                                                                    *ngIf="!shareholder.isOpen"></svg-icon>
                                                                                <svg-icon
                                                                                    src="assets/images/icon-down.svg"
                                                                                    *ngIf="shareholder.isOpen"></svg-icon>
                                                                            </button>
                                                                        </ng-container>
                                                                        <div *ngIf="!shareholder.shareholders || shareholder.shareholders.length === 0"
                                                                            style="width: 26px;">
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="nested-row-content">
                                                                        <div
                                                                            class="nested-cell name-cell">
                                                                            <div
                                                                                class="name-primary">
                                                                                {{shareholder.full_name}}
                                                                            </div>
                                                                            <div class="name-secondary"
                                                                                *ngIf="shareholder.document">
                                                                                {{shareholder.document}}
                                                                            </div>
                                                                        </div>
                                                                        <div
                                                                            class="nested-cell participation-cell">
                                                                            <!-- Mostra a porcentagem em relação ao Grupo principal, não o total dos participantes -->
                                                                            <ng-container
                                                                                *ngIf="shareholder.percentage">
                                                                                {{shareholder.percentage}}%
                                                                            </ng-container>
                                                                        </div>
                                                                        <div
                                                                            class="nested-cell actions-cell">
                                                                            <div
                                                                                class="icon-container">
                                                                                <!-- Botão de adicionar apenas para empresas (CNPJ), não para CPF -->
                                                                                <ng-container
                                                                                    *ngIf="shareholder.document && isCNPJ(shareholder.document) && shareholder.id !== undefined">
                                                                                    <app-tooltip
                                                                                        text="Adicionar Sócio"
                                                                                        position="top">
                                                                                        <button
                                                                                            (click)="handleTriggerForm(shareholder.id, true)"
                                                                                            class="action-button"
                                                                                            type="button">
                                                                                            <svg-icon
                                                                                                src="assets/images/icon-add.svg"></svg-icon>
                                                                                        </button>
                                                                                    </app-tooltip>
                                                                                </ng-container>
                                                                                <ng-container
                                                                                    *ngIf="shareholder.id !== undefined">
                                                                                    <app-tooltip
                                                                                        text="Editar"
                                                                                        position="top">
                                                                                        <button
                                                                                            (click)="handleEdit(shareholder)"
                                                                                            class="action-button"
                                                                                            type="button">
                                                                                            <svg-icon
                                                                                                src="assets/images/icon-edit.svg"></svg-icon>
                                                                                        </button>
                                                                                    </app-tooltip>
                                                                                    <app-tooltip
                                                                                        text="Excluir"
                                                                                        position="top">
                                                                                        <button
                                                                                            (click)="handleRemoveModal(shareholder)"
                                                                                            class="action-button"
                                                                                            type="button">
                                                                                            <svg-icon
                                                                                                src="assets/images/icon-trash.svg"></svg-icon>
                                                                                        </button>
                                                                                    </app-tooltip>
                                                                                </ng-container>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <!-- Tabela aninhada recursiva para shareholders de shareholders -->
                                                                <ng-container
                                                                    *ngTemplateOutlet="nestedShareholdersTemplate; context: { shareholders: shareholder.shareholders, parentItem: shareholder, level: 2 }"></ng-container>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-3" *ngIf="hasAtLeastOnePartner()">
                        <div class="col-12 col-lg-11 pl-0 pr-0">
                            <label
                                class="d-flex align-items-center pulverizada-checkbox">
                                <input type="checkbox" [checked]="pulverizada"
                                    (change)="pulverizada = $any($event.target).checked; onPulverizadaChange()">
                                <span class="ml-2">Pulverizar o restante das
                                    participações</span>
                            </label>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

        <div class="row no-gutters w-100">
            <div class="col-12 col-lg-10">
                <app-side-modal [active]="addAnotherModal"
                    title="Adicionar sócio" (onClose)="handleCloseModal()"
                    paddingBottom="0">
                    <div class="container">
                        <div class="row">
                            <ng-container
                                *ngIf="authService.user.active_register.register.role.slug !== getSlugLabel()">
                                <div class="col-12 col-lg-4">
                                    <app-masked-input [group]="form"
                                        controlName="document"
                                        label="CPF / CNPJ"
                                        placeholder="000.000.000-00"
                                        [errorText]="invalidDocument ? 'não é possível adicionar o próprio CNPJ como sócio!' : 'Campo inválido' "
                                        documentType="cpfOrCnpj">
                                    </app-masked-input>
                                    <app-spacer [bottom]="24"></app-spacer>
                                </div>
                            </ng-container>

                            <div class="col-12 col-lg-8">
                                <app-input [group]="form"
                                    controlName="full_name"
                                    label="Nome Completo / Razão Social"
                                    [readOnly]="foundPerson">
                                </app-input>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>
                        </div>

                        <div class="row">
                            <ng-container
                                *ngIf="authService.user.active_register.register.role.slug !== getSlugLabel()">
                                <div class="col-12 col-lg-4">
                                    <app-input [group]="form"
                                        controlName="percentage" type="number"
                                        label="% Participação" placeholder="00%"
                                        [max]="100">
                                    </app-input>
                                    <app-spacer [bottom]="24"></app-spacer>
                                </div>
                            </ng-container>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <app-radio [multiple]="true"
                                    formControlName="pep"
                                    [isChecked]="form.controls.pep.value">
                                    <div class="flex-1 d-flex flex-column">
                                        <span class="pep-title">PEP</span>
                                        <app-spacer [bottom]="8"></app-spacer>
                                        <span
                                            class="pep-description">Considera-se
                                            Pessoa Exposta Politicamente (PEP),
                                            nos
                                            termos da legislação
                                            em
                                            vigor, (i) agente público que
                                            desempenha ou tenha desempenhado,
                                            nos últimos
                                            cinco
                                            anos, no Brasil ou
                                            em
                                            países, territórios e dependências
                                            estrangeiras, cargos, empregos ou
                                            funções
                                            públicas relevantes; ou
                                            (ii)
                                            representante, familiar (parente na
                                            linha reta até primeiro grau,
                                            cônjuge,
                                            companheiro(a) ou
                                            enteado(a)).</span>
                                    </div>
                                </app-radio>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12">
                                <app-radio [multiple]="true"
                                    formControlName="pep_relationship"
                                    [isChecked]="form.controls.pep_relationship.value">
                                    <div class="flex-1 d-flex flex-column">
                                        <span class="option-title">
                                            Possuo relacionamento com pessoa
                                            politicamente exposta
                                        </span>
                                    </div>
                                </app-radio>

                                <ng-container
                                    *ngIf="form.controls.pep_relationship.value">
                                    <app-spacer [bottom]="24"></app-spacer>
                                    <div class="row ml-2">
                                        <div class="offset-1 col-7">
                                            <app-masked-input [group]="form"
                                                controlName="pep_relationship_document"
                                                label="CPF da pessoa"
                                                placeholder="000.000.000-00"
                                                [readOnly]="foundRelationPerson"
                                                mask="000.000.000-00">
                                            </app-masked-input>

                                            <app-spacer [bottom]="24">
                                            </app-spacer>
                                        </div>
                                    </div>

                                    <div class="row ml-2">
                                        <div class="offset-1 col-7">
                                            <app-input [group]="form"
                                                controlName="pep_relationship_name"
                                                label="Nome da pessoa"
                                                [maxLength]="60">
                                            </app-input>

                                            <app-spacer [bottom]="24">
                                            </app-spacer>
                                        </div>
                                    </div>

                                    <div class="row ml-2">
                                        <div class="offset-1 col-7">
                                            <app-input [group]="form"
                                                controlName="pep_bond"
                                                label="Vínculo">
                                            </app-input>
                                        </div>
                                    </div>
                                </ng-container>
                                <app-spacer [bottom]="48"></app-spacer>
                            </div>
                        </div>

                        <div class="row button-sticky">
                            <div class="col-12 col-lg-6">
                                <app-button (onClick)="handleCloseModal()"
                                    class="add-button" [outline]="true">
                                    Cancelar
                                </app-button>
                            </div>

                            <div class="col-12 col-lg-6">
                                <div class="text-right">
                                    <app-button
                                        (onClick)="handleTriggerForm(parentID, true)"
                                        [loading]="sending"
                                        [disabled]="getDisabled()"
                                        class="add-button">
                                        Salvar sócio
                                    </app-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </app-side-modal>

                <app-warning-modal [active]="removeModal"
                    (onClose)="removingData ? null : handleRemoveCancel()">
                    <h3>Você tem certeza?</h3>
                    <app-spacer [bottom]="24"></app-spacer>
                    <p>Você não poderá reverter essa ação!</p>
                    <app-spacer [bottom]="56"></app-spacer>

                    <app-button (onClick)="handleRemoveCancel()" [center]="true"
                        class="add-button" [disabled]="removingData">
                        Cancelar
                    </app-button>

                    <app-spacer [bottom]="8"></app-spacer>

                    <app-button (onClick)="removeData()" class="add-button"
                        [center]="true" [outline]="true"
                        [loading]="removingData" [disabled]="removingData">
                        Sim, apague!
                    </app-button>
                </app-warning-modal>
            </div>
        </div>
    </form>
</ng-container>

<app-warning-modal [active]="showWarning">
    <h3>Atenção</h3>
    <app-spacer [bottom]="24"></app-spacer>
    <p>
        Você atualizou um dado que impacta na composição societária. Por
        isso, é necessário que você revise a composição societária.
    </p>
    <app-spacer [bottom]="56"></app-spacer>

    <app-button (onClick)="showWarning = false" [center]="true">
        ok
    </app-button>
</app-warning-modal>

<!-- Carbon Warning Modal para mudança de documento -->
<app-carbon-warning-modal [active]="showDocumentChangeModal"
    [title]="getDocumentChangeModalTitle()"
    [message]="getDocumentChangeModalMessage()"
    [confirmText]="getDocumentChangeConfirmText()"
    [cancelText]="getDocumentChangeCancelText()"
    [confirmAction]="confirmDocumentChange.bind(this)"
    [cancelAction]="closeDocumentChangeModal.bind(this)"
    (onClose)="closeDocumentChangeModal()">
</app-carbon-warning-modal>

<!-- Template recursivo para shareholders aninhados -->
<ng-template #nestedShareholdersTemplate let-shareholders="shareholders"
    let-parentItem="parentItem" let-level="level">
    <div class="nested-table-container-recursive"
        *ngIf="shareholders && shareholders.length > 0 && parentItem.isOpen && !parentItem.collapsed">
        <div class="nested-table-header-recursive">
            <h6>Participantes de {{parentItem.full_name}}</h6>
            <div class="total-percentage-header">Participação total:
                {{ pulverizada && parentItem.full_name === getCompanyName() ?
                '100% (Pulverizada)' : getShareholdersPercentage(parentItem.id)
                + '%' }}</div>
        </div>
        <div class="nested-table-wrapper-recursive">
            <div class="nested-table-content-recursive">
                <!-- Títulos das colunas dentro do card -->
                <div class="nested-table-columns-header-recursive">
                    <div class="header-cell name-header">Nome / Razão Social
                    </div>
                    <div class="header-cell participation-header">% Participação
                    </div>
                    <div class="header-cell actions-header"></div>
                </div>
                <ng-container
                    *ngFor="let subShareholder of shareholders; let k = index">
                    <div class="nested-row-wrapper-recursive"
                        [class.has-nested-children]="subShareholder.shareholders && subShareholder.shareholders.length > 0">
                        <div class="nested-row-main-recursive">
                            <div class="nested-expand-container">
                                <ng-container
                                    *ngIf="subShareholder.shareholders && subShareholder.shareholders.length > 0">
                                    <button
                                        (click)="handleSetCollapsedShareholderRecursive(parentItem, k, subShareholder.isOpen)"
                                        class="expand-button">
                                        <svg-icon
                                            src="assets/images/icon-right.svg"
                                            *ngIf="!subShareholder.isOpen"></svg-icon>
                                        <svg-icon
                                            src="assets/images/icon-down.svg"
                                            *ngIf="subShareholder.isOpen"></svg-icon>
                                    </button>
                                </ng-container>
                                <div *ngIf="!subShareholder.shareholders || subShareholder.shareholders.length === 0"
                                    style="width: 26px;">
                                </div>
                            </div>
                            <div class="nested-row-content-recursive">
                                <div class="nested-cell name-cell">
                                    <div class="name-primary">
                                        {{subShareholder.full_name}}
                                    </div>
                                    <div class="name-secondary"
                                        *ngIf="subShareholder.document">
                                        {{subShareholder.document}}
                                    </div>
                                </div>
                                <div class="nested-cell participation-cell">
                                    {{subShareholder.percentage}}%
                                </div>
                                <div class="nested-cell actions-cell">
                                    <div class="icon-container">
                                        <!-- Botão de adicionar apenas para empresas (CNPJ), não para CPF -->
                                        <ng-container
                                            *ngIf="subShareholder.document && isCNPJ(subShareholder.document) && subShareholder.id !== undefined">
                                            <app-tooltip text="Adicionar Sócio"
                                                position="top">
                                                <button
                                                    (click)="handleTriggerForm(subShareholder.id, true)"
                                                    class="action-button"
                                                    type="button">
                                                    <svg-icon
                                                        src="assets/images/icon-add.svg"></svg-icon>
                                                </button>
                                            </app-tooltip>
                                        </ng-container>
                                        <ng-container
                                            *ngIf="subShareholder.id !== undefined">
                                            <app-tooltip text="Editar"
                                                position="top">
                                                <button
                                                    (click)="handleEdit(subShareholder)"
                                                    class="action-button">
                                                    <svg-icon
                                                        src="assets/images/icon-edit.svg"></svg-icon>
                                                </button>
                                            </app-tooltip>
                                            <app-tooltip text="Excluir"
                                                position="top">
                                                <button
                                                    (click)="handleRemoveModal(subShareholder)"
                                                    class="action-button">
                                                    <svg-icon
                                                        src="assets/images/icon-trash.svg"></svg-icon>
                                                </button>
                                            </app-tooltip>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Chamada recursiva para shareholders aninhados -->
                        <ng-container
                            *ngIf="subShareholder.shareholders && subShareholder.shareholders.length > 0">
                            <ng-container
                                *ngTemplateOutlet="nestedShareholdersTemplate; context: { shareholders: subShareholder.shareholders, parentItem: subShareholder, level: level + 1 }"></ng-container>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</ng-template>